import React from 'react';
import { Link} from 'react-router-dom';
import './_videoplayersidebar.scss';

import { MdSubscriptions, MdExitToApp, MdExplore,MdHistory,MdLibraryBooks,MdHome,MdSentimentDissatisfied,MdAccountCircle,MdLibraryMusic,MdMovie,MdVideogameAsset,MdStyle,MdChromeReaderMode,MdHighlight, MdVideocam } from 'react-icons/md';
import { BiNews } from 'react-icons/bi';
import { GiOlive } from 'react-icons/gi'
import { FaOutdent } from 'react-icons/fa';
import { FaPlusCircle } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { log_out } from '../../redux/actions/auth.action';

function Videoplayersidebar() {

//     const dispatch = useDispatch()
//    const logOutHandler = () => {
//       dispatch(log_out())
//    }
    return (
        <div className="videoplayersidebar">
            <nav className="sidebar"
        //  className={sidebar ? 'sidebar open' : 'sidebar'}
        //  onClick={() => handleToggleSidebar(false)}
         >
          
         {/* <Link to='/'> */}
            <li>
               <MdHome size={23} />
               <span>Home</span>
            </li>
         {/* </Link> */}
         {/* <Link to='/feed/subscriptions'> */}
            <li>
            <MdExplore size={23} />
            <span>Liked Video</span>
            </li>
         {/* </Link> */}

         <li>
            
               <MdSubscriptions size={23} />
               <span>Subscriptions</span>
         </li>
         <hr className="line-break"></hr>
         <li>
            <MdLibraryBooks size={23} />
            <span>Library</span>
            
         </li>

         <li>
         <MdHistory size={23} />
            <span>History</span>
         </li>
         <hr className="line-break"></hr>
         <p className="sign-in-tag">Sign in to like videos, comment, and subscribe.</p>
         <li
        //   onClick={logOutHandler}
          >
            <Link className="sign-in-button"><MdAccountCircle size={23} className="sign-in-icon" />SIGN OUT</Link>
         </li>
         <hr className="line-break"></hr>

         <p className="best-in-youtube">BEST OF YOUTUBE</p>

         <li>
            <MdLibraryMusic size={23} />
            <span>Music</span>
         </li>
         <li>
            <FaOutdent size={23} />
            <span>Sports</span>
         </li>
         <li>
            <MdVideogameAsset size={23} />
            <span>Gaming</span>
         </li>
         <li>
            <MdMovie size={23} />
            <span>movies</span>
         </li>
         <li>
            <BiNews size={23} />
            <span>News</span>
         </li>
         <li>
            <GiOlive size={23} />
            <span>Live</span>
         </li>
         <li>
            <MdStyle size={23} />
            <span>Fashion & Beauty</span>
         </li>
         <li>
            <MdChromeReaderMode size={23} />
            <span>Learning</span>
         </li>
         <li>
            <MdHighlight size={23} />
            <span>Sportlight</span>
         </li>
         <li>
            <MdVideocam size={23} />
            <span>360° Video</span>
         </li>

         <li>
            <MdSentimentDissatisfied size={23} />
            <span>I don't Know</span>
         </li>

         <hr />
          
          <li>
             <FaPlusCircle size={23} />
             <span>Browse channel</span>
          </li>
         <li>
            <MdExitToApp size={23} />
            <span>Log Out</span>
         </li>

         <hr />
         
      </nav>
        </div>
    )
}

export default Videoplayersidebar;
